// export const validaInterno = ({ value, formatMessage }) => {
//   console.log("Lanciato validaInterno");
//   console.log(value);
//   const internoRegex = /^[0]$|^[\d]{4}$/;
//   const isValid = internoRegex.test(value);
//   return !isValid
//     ? formatMessage({
//         id: 'invalidInterno',
//         defaultMessage: 'Valore interno non valido',
//       })
//     : null;
// };

// export const validaEsterno = ({ value, formatMessage }) => {
  
//   const esternoRegex =
//     /(\((00|\+)39\)|(00|\+)39)?[\s|-]?([0|3][\d]{2,3})[\s,\-,\/]?\d{3}[\s|-]?\d{3,4}/;
//   const isValid = esternoRegex.test(value) && value.length < 16;
//   return !isValid
//     ? formatMessage({
//         id: 'invalidEsterno',
//         defaultMessage: 'Valore esterno non valido',
//       })
//     : null;
// };


import { defineMessages } from 'react-intl';

defineMessages({
  invalidInterno: {
    id: 'invalidInterno',
    defaultMessage: 'Valore interno non valido',
  },
  invalidEsterno: {
    id: 'invalidEsterno',
    defaultMessage: 'Valore esterno non valido',
  },
});

export const validaInterno = (value) => {
  if (!value) return true; // Allow empty
  value = value.replace(/\s+/g, "");
  const internoRegex = /^\d{4}$/;
  const isValid = internoRegex.test(value);
  return isValid;
};

export const validaEsterno = (value) => {
  if (!value) return true; // Allow empty
  value = value.replace(/\s+/g, "");
  const esternoRegex =
    /^[\+]?[0-9]{0,3}\W?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/;
  const isValid = esternoRegex.test(value) && value.length < 16;
  return isValid;
};